<script>
  import { defaultEvmStores, signerAddress } from 'svelte-ethers-store'
  import { metaMaskExtensionInstallationLink } from '../../constants/constants'
  const backTop = () => {
    window.scroll({ top: 0 })
  }
</script>

<div
  class="connect-wallet-wrapper flex flex-text-center items-center
  column-direction">
  <img src="./images/meta.svg" alt="image" />
  <p>Please Connect Metamask and Select the Polygon network to get started.</p>
  <button
    class="btn-gradient-border btn-start-project" id="connect-wallet-button" on:click={backTop}
    on:click={() => {
      defaultEvmStores.setProvider().catch(() => {
        setTimeout(() => window.open(metaMaskExtensionInstallationLink, '_blank'), 1000)
      })
    }}>
    Connect Wallet
  </button>
</div>
